var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
const _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgLowFuel = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 183,
    viewBox: "0 0 335 183",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86719 110.893C9.14319 107.534 10.5042 104.173 11.9492 100.899L22.4942 105.747C21.0922 108.68 19.7732 111.7 18.5832 114.719L7.86719 110.893Z",
    fill: "#FF2E1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31836 125.221C4.25436 121.735 5.31636 118.289 6.46436 114.889L17.0514 118.674C15.9034 121.735 14.8824 124.839 13.9484 127.986L3.31836 125.221Z",
    fill: "#FF2E1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 139.848C0.638 136.319 1.36104 132.79 2.21204 129.303L12.842 132.11C11.991 135.256 11.269 138.445 10.631 141.676L0 139.848Z",
    fill: "#FF2E1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.622 0.382996C159.151 0.127996 162.724 0 166.295 0L166.423 21.559C163.488 21.345 160.513 21.26 157.579 21.26L155.622 0.382996Z",
    fill: "#40914E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.783 2.04114C144.269 1.48814 147.8 1.06414 151.37 0.723145L153.284 21.2601C150.307 21.3451 147.331 21.5151 144.354 21.7711L140.783 2.04114Z",
    fill: "#40914E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.115 5.01816C129.558 4.16816 133.046 3.40314 136.574 2.76514L140.103 22.1541C137.085 22.4941 134.108 22.9181 131.174 23.4301L126.115 5.01816Z",
    fill: "#40914E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.784 9.27002C115.143 8.12202 118.546 7.05903 121.989 6.08203L126.964 24.194C123.988 24.833 121.012 25.512 118.077 26.32L111.784 9.27002Z",
    fill: "#40914E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8379 14.7968C101.112 13.3518 104.429 11.9898 107.788 10.7158L113.996 27.4678C111.02 28.3608 108.086 29.3378 105.237 30.4018L97.8379 14.7968Z",
    fill: "#40914E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4453 21.515C87.5913 19.772 90.7383 18.114 93.9703 16.582L101.241 31.933C98.3493 33.081 95.5433 34.356 92.7363 35.674L84.4453 21.515Z",
    fill: "#40914E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6895 29.4241C74.6665 27.4261 77.6844 25.4701 80.7894 23.6421L88.9105 37.5461C86.1035 38.9901 83.3824 40.5221 80.7044 42.0941L71.6895 29.4241Z",
    fill: "#40914E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6992 38.3952C62.4632 36.1422 65.3122 33.9722 68.2452 31.8472L77.0902 44.3482C74.4112 46.0482 71.8172 47.8342 69.2652 49.6632L59.6992 38.3952Z",
    fill: "#40914E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5146 48.4301C51.0676 45.9221 53.7026 43.4982 56.4236 41.1602L65.8217 52.2151C63.3127 54.1701 60.8886 56.2111 58.5076 58.2951L48.5146 48.4301Z",
    fill: "#40914E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2686 59.3572C40.5636 56.6362 43.0306 54.0002 45.4976 51.4492L55.3186 61.1422C52.9796 63.3122 50.7266 65.5652 48.5146 67.9042L38.2686 59.3572Z",
    fill: "#40914E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9561 71.1789C31.0821 68.2869 33.2511 65.4379 35.5051 62.6309L45.6671 71.0509C43.4981 73.4319 41.458 75.8989 39.459 78.4499L28.9561 71.1789Z",
    fill: "#40914E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.793 83.8071C22.621 80.7031 24.534 77.642 26.533 74.665L36.9069 81.8501C34.9509 84.4451 33.1229 87.1231 31.3799 89.8441L20.793 83.8071Z",
    fill: "#40914E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7354 97.0719C15.2664 93.7989 16.9244 90.6089 18.6684 87.4629L29.1274 93.4589C27.4684 96.2209 25.8964 99.0699 24.4084 101.963L13.7354 97.0719Z",
    fill: "#40914E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.377 128.537C333.186 131.896 333.951 135.298 334.588 138.742L303.379 144.439C302.912 141.889 302.4 139.381 301.85 136.914L332.377 128.537Z",
    fill: "#40914E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.168 114.463C329.316 117.737 330.338 121.054 331.272 124.455L300.871 132.746C300.232 130.281 299.51 127.815 298.744 125.349L328.168 114.463Z",
    fill: "#40914E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.767 100.771C324.171 103.96 325.49 107.191 326.722 110.465L297.384 121.308C296.533 118.885 295.64 116.46 294.662 114.039L322.767 100.771Z",
    fill: "#40914E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.177 87.5908C317.878 90.6528 319.451 93.7558 320.983 96.9028L293.004 110.126C291.942 107.746 290.836 105.406 289.688 103.069L316.177 87.5908Z",
    fill: "#40914E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.645 79.8839L308.482 75.0469C310.437 77.9399 312.265 80.8729 314.05 83.8929L287.689 99.3259C286.457 96.9879 285.138 94.7339 283.777 92.5239L301.645 79.8839Z",
    fill: "#40914E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.679 63.186C301.89 65.906 304.017 68.67 306.058 71.519L281.523 88.91C280.077 86.698 278.589 84.53 277.017 82.405L299.679 63.186Z",
    fill: "#40914E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.9 52.0879C292.367 54.6379 294.705 57.2329 296.959 59.9109L285.712 69.4559L274.464 79.0019C272.849 76.8749 271.148 74.8349 269.406 72.8369L289.9 52.0879Z",
    fill: "#40914E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.228 41.8818C281.863 44.2208 284.415 46.6018 286.923 49.0688L266.599 69.6488C264.771 67.6488 262.9 65.7358 260.986 63.8648L279.228 41.8818Z",
    fill: "#40914E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.662 32.6562C270.512 34.7392 273.275 36.9072 275.996 39.1622L257.926 60.9302C255.928 59.0602 253.887 57.2743 251.803 55.5312L267.662 32.6562Z",
    fill: "#40914E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.333 24.4492C258.353 26.2782 261.286 28.1912 264.177 30.1892L248.487 52.8512C246.362 51.1932 244.148 49.5782 241.896 48.0052L255.333 24.4492Z",
    fill: "#40914E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.32 17.3071C245.466 18.8791 248.613 20.5371 251.675 22.2821L238.367 45.6251C236.07 44.0941 233.689 42.6491 231.308 41.2441L242.32 17.3071Z",
    fill: "#40914E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.715 11.354C232.031 12.629 235.264 14.033 238.494 15.479L227.61 39.163C225.143 37.801 222.635 36.568 220.125 35.377L228.715 11.354Z",
    fill: "#40914E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.64 6.63281C218.042 7.61181 221.4 8.67381 224.716 9.86481L216.214 33.5908C213.661 32.4848 211.025 31.4228 208.39 30.4448L214.64 6.63281Z",
    fill: "#40914E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.14 3.146C203.669 3.826 207.115 4.59198 210.515 5.48398L204.351 28.998C201.671 28.106 198.908 27.255 196.144 26.533L200.14 3.146Z",
    fill: "#40914E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.429 0.937012C188.958 1.27701 192.488 1.78701 195.974 2.38101L192.019 25.47C189.255 24.791 186.408 24.152 183.558 23.642L185.429 0.937012Z",
    fill: "#40914E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.547 0C174.119 0.086 177.691 0.255979 181.177 0.509979L179.349 22.918C176.5 22.493 173.566 22.153 170.675 21.898L170.547 0Z",
    fill: "#40914E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.507 83.084H158.131V97.5399H141.507V83.084ZM140.783 78.918H158.855C160.853 78.918 162.468 80.533 162.468 82.531V118.674H164.296V122.287H162.468H137.169H135.384V118.674H137.169V82.531C137.169 80.533 138.784 78.918 140.783 78.918Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.042 82.1059C163.233 81.2549 165.614 78.8749 166.593 79.5969C173.735 84.6559 173.778 84.6559 177.351 87.2089C178.71 88.1849 177.818 88.9089 177.818 88.9089L177.179 89.4599V115.229C177.179 120.671 166.338 120.502 166.338 115.229V100.771H159.832V97.1579H166.338C170.632 97.1579 169.951 100.856 169.951 100.771V115.229H173.565V92.5229C170.377 89.0369 170.505 88.9089 164.042 82.1059Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5813 143.372C16.3863 142.923 15.0183 140.768 15.4683 138.572C15.9333 136.417 18.0723 135.011 20.2823 135.499L158.336 160.763L154.926 176.831L18.5813 143.372Z",
    fill: "#FCC300"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.185 162.937C150.096 157.069 158.004 155.538 163.873 159.45C169.698 163.405 171.27 171.313 167.316 177.181C163.404 183.005 155.496 184.579 149.628 180.625C143.802 176.712 142.23 168.761 146.185 162.937Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 177.266V151.455H19.049V155.835H5.18799V161.534H18.071V165.912H5.18799V172.886H19.56V177.266H0Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M313.319 177.266V151.455H331.006V155.835H318.505V161.958H329.305V166.295H318.505V177.266H313.319Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLowFuel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/low-fuel.661cd009.svg";
export { ForwardRef as ReactComponent };